<template>
    <div class="sl-footer">
        <staff-footer-contents />
    </div>
</template>

<script setup>
import StaffFooterContents from '@/components/footer/StaffFooterContents.vue';
</script>
